// extracted by mini-css-extract-plugin
export default {"mainContent":"dashboard_mainContent__uTLEL","mainCollapsed":"dashboard_mainCollapsed__6j4Tw"};